<template>
  <div class="draggable-menu">
    <i class="triangle" />
    <draggable
      :options="{draggable: '.draggable-item'}"
      class="draggable-content"
      v-model="dragItems"
    >
      <div
        v-for="( item, index ) in dragItems"
        :key="'dragIndex' + index"
        class="draggable-item"
      >
        <input
          type="checkbox"
          :disabled="!item.selectable"
          :value="item"
          v-model="selectedColumns"
        >
        <span class="title">{{ $t(item.title) }}</span>
      </div>
    </draggable>
    <div class="btns">
      <div
        class="clearSelect"
        @click="clearSelect"
      >{{ $t('action.reset').toUpperCase() }}</div>
      <div
        class="confirm"
        @click="confirm"
      >{{ $t('action.confirm').toUpperCase() }}</div>
    </div>
  </div>
</template>

<script>
import lodash from 'lodash'
import draggable from 'vuedraggable'
import localStore from 'services/localstore'

import { TableHeaderKey, draggableItems } from './Contains'

export default {
  name: 'DraggableMenu',
  components: {
    draggable,
  },
  props: {
    dragArray: {
      type: Array,
      default: () => [],
    },
    userId: {
      type: String,
      default: '',
    },
    asyncInitDragItems: {
      type: Function,
      default: () => {},
    },
  },
  data () {
    return {
      dragging: false,
      dragItems: this.dragArray,
      selectedColumns: this.dragArray.filter(item => item.selected),
    }
  },
  methods: {
    updateInternalData (items) {
      this.dragItems = lodash.cloneDeep(items)
      this.selectedColumns = this.dragItems.filter(item => item.selected)
    },
    updateSelectedItem () {
      this.dragItems.forEach(item => {
        item.selected = this.selectedColumns.includes(item)
      })
    },
    async confirm () {
      this.updateSelectedItem()
      await this.saveInLocalStore()
    },
    async clearSelect () {
      this.updateInternalData(draggableItems)
      await this.saveInLocalStore()
    },
    async saveInLocalStore () {
      const result = await localStore.setItem(this.userId + '_' + TableHeaderKey, this.dragItems)
      this.$emit('update-items', this.dragItems)
      return result
    },
  },
  async mounted () {
    if (!this.dragItems.length && typeof this.asyncInitDragItems === 'function') {
      const result = await this.asyncInitDragItems()
      this.updateInternalData(result)
    }
  },
}
</script>

<style lang="scss" scoped>
.draggable-menu {
  width: 275px;
  display: block;
  position: absolute;
  background: #FFFFFF;
  z-index: 10;
  font-family: Verdana;
  font-size: 14px;
  color: #0C3A58;
  right: 10px;
  border: 1px solid #E0E1E4;
  top: 55px;
  font-weight: 400;

  .btns {
    border-top: 1px solid #E0E1E4;
    padding: 6px 12px;
    position: relative;
    height: 43px;
    .btn {
      border: 1px solid #0C3A58;
      height: 30px;
      text-align: center;
      line-height: 30px;
      float: left;
    }
    .clearSelect {
      @extend .btn;
      width: 80px;
      cursor: pointer;
    }
    .confirm {
      @extend .btn;
      width: 100px;
      margin-left: 13px;
      cursor: pointer;
    }
  }
}
.triangle {
  height: 7px;
  width: 7px;
  display: inline-block;
  transform: rotate(45deg);
  position: absolute;
  left: 170px;
  border-left: 1px solid #E0E1E4;
  border-top: 1px solid #E0E1E4;
  top: -5px;
  background: white;
}

.draggable-content {
  height: 505px;
  overflow-y: auto;
  padding: 0 0 15px 0;
}
.draggable-item {
  cursor: move;
  padding-left: 20px;
  span, input {
    vertical-align: middle;
  }
  height: 40px;
  line-height: 40px;
  z-index: 100;
  input {
    margin-right: 15px;
  }
  input, input:after {
    width: 18px;
    height: 18px;
    font-size: 17px;
    top: -1px;
    left: -1px;
    cursor: pointer;
  }
  input:disabled::after {
    background-color: #b5b5b5
  }
}

.draggable-item:last-child {
  margin-bottom: 0;
}
</style>
